import React from "react";
import { injectIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import informe from "../../assets/informe.png";
import logoMedical from "../../assets/logo-medical.png";
import { useGameTexts } from "../../hooks/useGameTexts";
import { SERVER_URL } from "../../api";
import NextButton from "../../components/NextButton";
import { useLang } from "../../translations/i18n";
import { ROUTES } from "../../utils/constants";

function buildImageUrl(value, fallback) {
	if (!value || typeof value !== "string") return fallback;
	if (value.startsWith("http")) return value;
	return `${SERVER_URL.replace(/\/$/, "")}/${value.replace(/^\//, "")}`;
}

function Scenario2Intro({ intl }) {
	const lang = useLang();
	const navigate = useNavigate();
	const group = useSelector((state) => state.group);
	const { texts, ready } = useGameTexts(group?.game);

	const title = texts["scenario2.intro.title"] ?? "";
	const content = texts["scenario2.intro.content"] ?? "";
	const logoUrl = texts["scenario2.intro.logo"] ? buildImageUrl(texts["scenario2.intro.logo"], null) : null;
	const informeUrl = texts["scenario2.intro.informe"] ? buildImageUrl(texts["scenario2.intro.informe"], null) : null;

	const contentLines = (content || "").trim().split(/\n/).filter(Boolean);
	const headline = contentLines[0] ?? "";
	const informeLabel = contentLines.slice(1).join("\n").trim() ?? "";

	const logoSrc = logoUrl || logoMedical;
	const informeSrc = informeUrl || informe;

	// Misma estructura siempre para evitar reorden/reescalado al cargar textos
	return (
		<div className="h-100">
			<div className="container-fluid bg-internas">
				<div style={{ paddingTop: "6vh", paddingLeft: "6vh" }}>
					<img width={240} src={logoSrc} alt="" />
				</div>
				<div
					style={{ paddingLeft: "6vh", minHeight: "60vh" }}
					className="row d-flex justify-content-start align-items-start mt-5 pt-5"
				>
					{!ready ? (
						<div className="col-4 txtWhite d-flex align-items-center">
							<div className="txtWhite">Cargando...</div>
						</div>
					) : (
						<>
							<div className="col-4 txtWhite">
								<div
									className="txtWhite txt20"
									style={{ letterSpacing: 3 }}
								>
									ESCENARIO 2
								</div>
								<div
									className="txtWhite txt30 bold mt-3"
									style={{ letterSpacing: 3 }}
								>
									{title && title.indexOf("<") >= 0 ? <span dangerouslySetInnerHTML={{ __html: title }} /> : title}
								</div>
								<div className="txt16 bold mt-5 w-75">
									{headline && headline.indexOf("<") >= 0 ? <span dangerouslySetInnerHTML={{ __html: headline }} /> : headline}
								</div>
								{informeLabel ? (
									<div className="mt-2">
										{informeLabel.indexOf("<") >= 0 ? <span dangerouslySetInnerHTML={{ __html: informeLabel }} /> : informeLabel}
									</div>
								) : null}
							</div>
							<div
								className="d-flex justify-content-end"
								style={{
									position: "absolute",
									right: "7%",
									bottom: "0%",
								}}
							>
								<div className="col-8">
									<img height={580} src={informeSrc} alt="" />
								</div>
							</div>
						</>
					)}
				</div>
			</div>
			<div
				className="container"
				style={{
					position: "absolute",
					bottom: "4vh",
				}}
			>
				<div className="d-flex justify-content-end">
					<NextButton navigateTo={ROUTES.SCENARIO2} />
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Scenario2Intro);
